import { Select } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BiGridAlt } from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { Button, Col, Modal, ModalBody, Row, Spinner } from "reactstrap";
import FormInput from "../formInput/FormInput";
const AddNewCategory = ({
  isOpen,
  toggle,
  onSubmit,
  selectedCategory,
  setSelectedCategory,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    category: "",
    category_type: "",
    category_image: null,
    categoryImageURL: "",
  });
  const handleSave = () => {
    if (!data.category || !data.category_type) {
      toast.error("Form data incomplete");
      return;
    }
    // const duplicate = all_categories?.find(
    //   (i) =>
    //     i?.categoryName?.trim().toLowerCase() ===
    //     data?.category?.trim().toLowerCase()
    // );
    // if (duplicate) {
    //   toast.error("Provided Category Already Available");
    //   return;
    // }
    onSubmit(
      data,
      () =>
        setData({
          category: "",
          category_type: "",
          category_image: null,
          categoryImageURL: "",
        }),
      setLoading
    );
  };
  useEffect(() => {
    if (isOpen && selectedCategory) {
      setData({
        category: selectedCategory?.categoryName ?? "",
        category_type: selectedCategory?.categoryType ?? "",
        category_image: selectedCategory?.categoryImage ?? null,
        categoryImageURL: selectedCategory?.categoryImageURL ?? "",
      });
    }
  }, [selectedCategory, isOpen]);
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="md"
      onClosed={() => {
        setData({
          category: "",
          category_type: "",
          category_image: null,
          categoryImageURL: "",
        });
      }}
    >
      <ModalBody className="p-0 border-0">
        <div className="modern-modal-header d-flex justify-content-between align-items-center p-4 border-bottom bg-light rounded-top">
          <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
            <BiGridAlt className="text-primary" size={20} /> {selectedCategory ? "Edit" : "Add"} Category
          </h5>
          <IoCloseSharp
            size={24}
            className="text-muted pointer hover-opacity-75"
            onClick={toggle}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Row className="mb-0 p-4">
          <Col md={12}>
            <FormInput
              type="text"
              label="Category"
              placeholder="Category Name..."
              size="large"
              value={data.category}
              handleChange={(e) =>
                setData({ ...data, category: e.target.value })
              }
            />
          </Col>
          <Col md={12} className="mb-3">
            <label className="fw-bold mb-1">Category Type</label>
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="Select Type"
              size="large"
              options={[
                { value: "Hardware", label: "Hardware" },
                { value: "Software", label: "Software" },
              ]}
              onSelect={(value) => setData({ ...data, category_type: value })}
              value={data.category_type}
            />
          </Col>
          <Col md={12} className="mb-3">
            {data?.categoryImageURL && (
              <div className="position-relative d-inline-block me-2 mb-2">
                <span
                  onClick={() => setData({ ...data, categoryImageURL: "" })}
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    color: "red",
                    borderRadius: "50%",
                    cursor: "pointer",
                    padding: "2px",
                    zIndex: 1,
                  }}
                >
                  <IoCloseSharp
                    size={18}
                    color="red"
                    className="bg-danger text-white rounded-pill"
                  />
                </span>
                <img
                  className="rounded-3 border border-1"
                  height={50}
                  width={50}
                  src={data?.categoryImageURL}
                  alt="URL"
                />
              </div>
            )}
            <div>
              <FormInput
                type="text"
                label="Category Image URL"
                placeholder={"Image URL"}
                size="large"
                value={data.categoryImageURL}
                handleChange={(e) =>
                  setData({ ...data, categoryImageURL: e.target.value })
                }
              />
            </div>
          </Col>
          <Col md={12}>
            {data?.category_image && (
              <div className="position-relative d-inline-block me-2 mb-2">
                <span
                  onClick={() => setData({ ...data, category_image: null })}
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    padding: "2px",
                    zIndex: 1,
                  }}
                >
                  <IoCloseSharp
                    size={18}
                    color="red"
                    className="bg-danger text-white rounded-pill"
                  />
                </span>
                <img
                  className="rounded-3 border border-1"
                  height={50}
                  width={50}
                  src={
                    typeof data?.category_image === "object"
                      ? URL.createObjectURL(data?.category_image)
                      : data?.category_image
                  }
                  alt="File"
                />
              </div>
            )}
            <FormInput
              type="file"
              label="Category Image"
              size="large"
              handleChange={(e) =>
                setData({ ...data, category_image: e.target.files[0] })
              }
            />
          </Col>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="text-muted" style={{ fontSize: "0.8rem" }}>
              {selectedCategory?.createdBy?.username && (
                <div>
                  <span className="fw-semibold">Created by:</span> {selectedCategory.createdBy.username}
                  {selectedCategory.createdAt && ` on ${new Date(selectedCategory.createdAt).toLocaleString()}`}
                </div>
              )}
              {selectedCategory?.updatedBy?.username && (
                <div>
                  <span className="fw-semibold">Last updated by:</span> {selectedCategory.updatedBy.username}
                  {selectedCategory.updatedAt && ` on ${new Date(selectedCategory.updatedAt).toLocaleString()}`}
                </div>
              )}
            </div>
            <div className="d-flex gap-2">
              <Button
                className="bg-white text-black border mx-2"
                onClick={toggle}
                size="sm"
              >
                Cancel
              </Button>
              <Button
                className="bg-primary-color text-white"
                onClick={handleSave}
                size="sm"
                disabled={loading}
              >
                {loading ? <Spinner size="sm" /> : "Save"}
              </Button>
            </div>
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default AddNewCategory;
